// Configuración de botones del toolbar para estados logísticos
export interface ToolbarButton {
  key: string;
  link: string;
  status_id?: number;
}

// Configuración de botones del toolbar para estados logísticos
export const toolbarButtons: ToolbarButton[] = [
  { key: 'all', link: '#' }, // Todos - sin ID específico
  { key: 'no_logistic_status', link: '#', status_id: 1 }, // Sin estado logístico
  { key: 'in_transit', link: '#', status_id: 2 }, // En tránsito
  { key: 'in_delivery', link: '#', status_id: 3 }, // En reparto
  { key: 'pickup_point', link: '#', status_id: 4 }, // Punto de recogida
  { key: 'delivered', link: '#', status_id: 5 }, // Entregado
  { key: 'returned_to_sender', link: '#', status_id: 6 }, // Devuelto al remitente
];

// Configuración de colores para estados logísticos del envío
export const statusColorMap: Record<number, { bg: string; text: string }> = {
  1: {
    // Sin estado logístico - No logistic status
    bg: 'bg-card-border',
    text: 'text-text',
  },
  2: {
    // En tránsito - In transit
    bg: 'bg-card-border light:bg-bg-warning',
    text: 'text-warning',
  },
  3: {
    // En reparto - In delivery
    bg: 'bg-card-border light:bg-bg-info',
    text: 'text-info',
  },
  4: {
    // Punto de recogida - Pickup point
    bg: 'bg-card-border light:bg-badge-status-4',
    text: 'text-badge-status-4',
  },
  5: {
    // Entregado - Delivered
    bg: 'bg-bg-success',
    text: 'text-success',
  },
  6: {
    // Devuelto al remitente - Returned to sender
    bg: 'bg-card-border light:bg-bg-error',
    text: 'text-error',
  },
};
